export const usePortraitDetect = () => {
    return window.matchMedia("(orientation: portrait)").matches;
};
